// frontend/src/services/vehicleAiApi.js
// Client for the Claude-backed vehicle AI endpoints (diagnose / brief / review-quote).
//
// ⚠️ Uses the shared `api` instance from ./api, whose baseURL already ends in
// `/api` — paths below MUST NOT include the `/api/` prefix (see api.js header).
import api, { AI_TIMEOUT_MS } from './api';

const vehicleAiApi = {
  diagnose: (payload) => api.post('/ai/diagnose', payload, { timeout: AI_TIMEOUT_MS }).then((r) => r.data),
  brief: (payload) => api.post('/ai/brief', payload, { timeout: AI_TIMEOUT_MS }).then((r) => r.data),
  reviewQuote: (payload) => api.post('/ai/review-quote', payload, { timeout: AI_TIMEOUT_MS }).then((r) => r.data),
};

export default vehicleAiApi;
